/* import __COLOCATED_TEMPLATE__ from './fee.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './fee.module.scss';

@classic
@classNames(styles.component)
export default class PracticeWebsiteEditMenuFee extends Component {}
